import React from 'react';
import cx from 'classnames';
import { appContext } from '../../util/decorators';

@appContext
export default class ExpandableBox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { expanded } = this.state;

    return (
      <div className={cx('expandable-box', {'is-expanded': expanded, 'is-collapsed': !expanded})}>
        <div style={{maxHeight: this.props.initialHeight}} className="expandable-box-content">
          {this.props.children}
        </div>

        <button onClick={() => this.setState({expanded: true})} className="expandable-box-button vs-button vs-button-primary vs-button-small vs-button-block">
            {this.context.app.t('ExpandableBox.show_more')}
        </button>
      </div>
    );
  }
}

ExpandableBox.propTypes = {
  initialHeight: React.PropTypes.string,
  children: React.PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/component/NewsFeed/ExpandableBox.jsx